import React from 'react';

import { useIntl } from 'react-intl-next';

import Avatar from '@atlaskit/avatar';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';

import { messages } from './messages';

interface ProfileAvatarProps {
	user?: { name: string; picture: string } | null | undefined;
}

/**
 * Assignee is used in Jira search results.
 */
export const Assignee = ({ user }: ProfileAvatarProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const tooltipText = user
		? formatMessage(messages.assignee, { assigneeName: user.name })
		: formatMessage(messages.unassigned);

	const name = user ? user.name : formatMessage(messages.unassigned);

	return (
		<Inline space="space.025" alignBlock="center">
			<Tooltip content={tooltipText}>
				{(tooltipProps) => (
					<Stack alignBlock="center" {...tooltipProps}>
						<Avatar src={user?.picture} appearance="circle" size="xsmall" name={name} />
					</Stack>
				)}
			</Tooltip>
			<Text color="color.text.subtlest" maxLines={1}>
				{name}
			</Text>
		</Inline>
	);
};
